// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EditorialProcessRouteImport } from './routes/editorial-process'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as PerguntasFrequentesRouteImport } from './routes/perguntas-frequentes'
import { Route as ProcessoEditorialRouteImport } from './routes/processo-editorial'
import { Route as ArticlesIndexRouteImport } from './routes/articles/index'
import { Route as ArticlesSlugRouteImport } from './routes/articles/$slug'
import { Route as ArtigosIndexRouteImport } from './routes/artigos/index'
import { Route as ArtigosSlugRouteImport } from './routes/artigos/$slug'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as GuiasBolhasNaCabecaDoPenisRouteImport } from './routes/guias/bolhas-na-cabeca-do-penis'
import { Route as GuiasPequenasBolinhasNoPenisRouteImport } from './routes/guias/pequenas-bolinhas-no-penis'
import { Route as GuidesIndexRouteImport } from './routes/guides/index'
import { Route as GuidesSlugRouteImport } from './routes/guides/$slug'
import { Route as BlogEnSlugRouteImport } from './routes/blog/en/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EditorialProcessRoute = EditorialProcessRouteImport.update({
            id: '/editorial-process',path: '/editorial-process',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const PerguntasFrequentesRoute = PerguntasFrequentesRouteImport.update({
            id: '/perguntas-frequentes',path: '/perguntas-frequentes',getParentRoute: () => rootRouteImport
          })
const ProcessoEditorialRoute = ProcessoEditorialRouteImport.update({
            id: '/processo-editorial',path: '/processo-editorial',getParentRoute: () => rootRouteImport
          })
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => rootRouteImport
          })
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
            id: '/articles/$slug',path: '/articles/$slug',getParentRoute: () => rootRouteImport
          })
const ArtigosIndexRoute = ArtigosIndexRouteImport.update({
            id: '/artigos/',path: '/artigos/',getParentRoute: () => rootRouteImport
          })
const ArtigosSlugRoute = ArtigosSlugRouteImport.update({
            id: '/artigos/$slug',path: '/artigos/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const GuiasBolhasNaCabecaDoPenisRoute = GuiasBolhasNaCabecaDoPenisRouteImport.update({
            id: '/guias/bolhas-na-cabeca-do-penis',path: '/guias/bolhas-na-cabeca-do-penis',getParentRoute: () => rootRouteImport
          })
const GuiasPequenasBolinhasNoPenisRoute = GuiasPequenasBolinhasNoPenisRouteImport.update({
            id: '/guias/pequenas-bolinhas-no-penis',path: '/guias/pequenas-bolinhas-no-penis',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const BlogEnSlugRoute = BlogEnSlugRouteImport.update({
            id: '/blog/en/$slug',path: '/blog/en/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,EditorialProcessRoute: EditorialProcessRoute,FaqRoute: FaqRoute,PerguntasFrequentesRoute: PerguntasFrequentesRoute,ProcessoEditorialRoute: ProcessoEditorialRoute,ArticlesSlugRoute: ArticlesSlugRoute,ArtigosSlugRoute: ArtigosSlugRoute,BlogSlugRoute: BlogSlugRoute,GuiasBolhasNaCabecaDoPenisRoute: GuiasBolhasNaCabecaDoPenisRoute,GuiasPequenasBolinhasNoPenisRoute: GuiasPequenasBolinhasNoPenisRoute,GuidesSlugRoute: GuidesSlugRoute,ArticlesIndexRoute: ArticlesIndexRoute,ArtigosIndexRoute: ArtigosIndexRoute,BlogIndexRoute: BlogIndexRoute,GuidesIndexRoute: GuidesIndexRoute,BlogEnSlugRoute: BlogEnSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)